import { Link } from 'react-router';
import { sumEstimates } from '@tahi/core';
import type { TileSize } from '../../../tiles/registry';
import { Money } from '../../../ui';
import { copy } from '../copy';
import { useOpenItems } from '../hooks';
import { FOCUS } from '../styles';

/** What's on the list and its estimated total; wide shows the first few items. */
export function ListTile({ size }: { size: TileSize; config: unknown }) {
  const items = useOpenItems() ?? [];
  const estimate = sumEstimates(items);
  const shown = size === 'wide' ? items.slice(0, 3) : [];
  return (
    <div className="flex flex-col gap-1" data-testid="shopping-list-tile">
      <div className="flex items-center justify-between gap-2">
        <Link
          to="/m/shopping"
          aria-label={copy.openList}
          className={`inline-flex min-h-11 min-w-0 items-center text-sm text-muted ${FOCUS}`}
        >
          {items.length === 0 ? copy.nothingToBuy : copy.items(items.length)}
        </Link>
        <Link
          to="/m/shopping"
          aria-label={copy.addItem}
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary text-2xl text-fg ${FOCUS}`}
        >
          +
        </Link>
      </div>
      {estimate > 0 ? (
        <Money minor={estimate} cents="auto" className="block text-[28px] leading-tight" />
      ) : null}
      {shown.length > 0 ? (
        <ul className="mt-1 flex flex-col gap-1 text-sm">
          {shown.map((i) => (
            <li key={i.id} className="flex justify-between gap-3">
              <span className="min-w-0 truncate text-fg">{i.name}</span>
              {i.estimateMinor ? (
                <Money
                  minor={i.estimateMinor}
                  cents="auto"
                  animate={false}
                  className="shrink-0 text-muted"
                />
              ) : null}
            </li>
          ))}
          {items.length > shown.length ? (
            <li className="text-muted">{copy.moreItems(items.length - shown.length)}</li>
          ) : null}
        </ul>
      ) : null}
    </div>
  );
}
